import { render, staticRenderFns } from "./ColorSubModule.vue?vue&type=template&id=91b2392c&"
import script from "./ColorSubModule.vue?vue&type=script&lang=ts&"
export * from "./ColorSubModule.vue?vue&type=script&lang=ts&"
import style0 from "./ColorSubModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports